var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32.5004,
    cy: 32.4999,
    r: 28.2313,
    fill: "#B3D237",
    stroke: "#B3D237",
    strokeWidth: 0.737443
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.5013 43.3332C38.4844 43.3332 43.3346 38.4829 43.3346 32.4998C43.3346 26.5168 38.4844 21.6665 32.5013 21.6665C26.5182 21.6665 21.668 26.5168 21.668 32.4998C21.668 38.4829 26.5182 43.3332 32.5013 43.3332Z",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 26V32.5L36.8333 34.6667",
    stroke: "#1F1F21",
    strokeWidth: 0.737443,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.9c2902d4f3b90ae2194d9703f40d06cd.svg";
export { ForwardRef as ReactComponent };